// Коды мобильных операторов Казахстана
export const kazakhMobileCodes = [
  '700', // АЛТЕЛ
  '701', // AO «Kcell» (Kcell)
  '702', // AO «Kcell» (Kcell)
  '703', // резерв для сотовых операторов
  '704', // резерв для сотовых операторов
  '705', // ТОО «КаР-Тел» (Beeline)
  '706', // ТОО «КаР-Тел» (izi)
  '707', // ТОО «Мобайл Телеком-Сервис» (Tele2)
  '708', // АЛТЕЛ
  '709', // резерв для сотовых операторов
  '747', // ТОО «Мобайл Телеком-Сервис» (Tele2, FMOBILE)
  '750', // АО «Казахтелеком» (коммутируемый доступ)
  '751', // АО «Казахтелеком» (передача данных)
  '760', // АО «Казахтелеком» (Спутниковая сеть Кулан)
  '761', // АО «Казахтелеком»
  '762', // АО «NURSAT»
  '763', // АО «Арна»
  '764', // АО «2 Day Telecom»
  '771', // ТОО «КаР-Тел» (Beeline)
  '775', // AO «Kcell» (Activ)
  '776', // ТОО «КаР-Тел» (Beeline)
  '777', // ТОО «КаР-Тел» (Beeline)
  '778', // AO «Kcell» (Activ)
];

/**
 * Валидация казахстанского мобильного номера
 * @param phone - номер телефона в формате строки (только цифры)
 * @returns объект с результатом валидации и описанием ошибки
 */
export const validateKazakhPhone = (phone: string): { isValid: boolean; error?: string } => {
  // Удаляем все символы кроме цифр
  const cleanPhone = phone.replace(/\D/g, '');
  
  // Проверяем длину номера
  if (cleanPhone.length !== 11 && cleanPhone.length !== 10) {
    return { 
      isValid: false, 
      error: 'Номер должен содержать 10 или 11 цифр' 
    };
  }
  
  let phoneToValidate = cleanPhone;
  
  // Если номер состоит из 11 цифр, проверяем первую цифру
  if (cleanPhone.length === 11) {
    const firstDigit = cleanPhone[0];
    if (firstDigit !== '7' && firstDigit !== '8') {
      return { 
        isValid: false, 
        error: 'Номер должен начинаться с 7 или 8' 
      };
    }
    // Убираем первую цифру для дальнейшей проверки
    phoneToValidate = cleanPhone.slice(1);
  }
  
  // Проверяем, что после первой цифры идет 7
  if (phoneToValidate[0] !== '7') {
    return { 
      isValid: false, 
      error: 'После кода страны должна идти цифра 7' 
    };
  }
  
  // Извлекаем код оператора (3 цифры после 7)
  const operatorCode = phoneToValidate.slice(0, 3);
  
  // Проверяем, что код оператора входит в список допустимых
  if (!kazakhMobileCodes.includes(operatorCode)) {
    return { 
      isValid: false, 
      error: 'Недопустимый код мобильного оператора' 
    };
  }
  
  return { isValid: true };
};

/**
 * Форматирование номера телефона для отображения
 * @param phone - номер телефона
 * @returns отформатированный номер
 */
export const formatKazakhPhone = (phone: string): string => {
  const cleanPhone = phone.replace(/\D/g, '');
  
  if (cleanPhone.length === 0) return '';
  
  // Если номер начинается с 8, заменяем на +7
  let formattedPhone = cleanPhone;
  if (cleanPhone.length === 11 && cleanPhone[0] === '8') {
    formattedPhone = '7' + cleanPhone.slice(1);
  }
  
  // Если номер состоит из 10 цифр, добавляем +7
  if (formattedPhone.length === 10) {
    formattedPhone = '7' + formattedPhone;
  }
  
  // Форматируем как +7 (XXX) XXX-XX-XX
  if (formattedPhone.length === 11 && formattedPhone[0] === '7') {
    return `+7 (${formattedPhone.slice(1, 4)}) ${formattedPhone.slice(4, 7)}-${formattedPhone.slice(7, 9)}-${formattedPhone.slice(9, 11)}`;
  }
  
  return phone;
};
